<template>
  <modal-frame :submit="submit"
               :shape-width="600"
               :shape-height="!isWinepoint ? 320 : 270"
               :disable-cancel-button="true"
               class="modal-frame">

    <div class="title-wrapper">

      <span class="title">{{ param.email }} 계정 설정 변경</span>

    </div>

    <div class="contents-wrapper">

      <div class="contents">
        <p class="contents-header">소속</p>
        <div class="contents-text">
          <layout-radio-button v-model="division"
                               name="division"
                               :select-list="['winepoint', 'fc', 'store']"
                               :view-list="['와인포인트', '센터', '매장']"/>
        </div>
      </div>

      <div class="contents">
        <p class="contents-header">등급</p>
        <div class="contents-text">
          <layout-radio-button v-model="type"
                               name="type"
                               :select-list="['manager', 'staff']"
                               :view-list="['매니저', '스태프']"/>
        </div>
      </div>

    </div>

  </modal-frame>
</template>

<script>
import LayoutRadioButton from '@/spa/components/LayoutRadioButton';
import ModalFrame from '../ModalFrame';

export default {
  name: 'ModalModifyUserState',
  components: {
    ModalFrame,
    LayoutRadioButton,
  },
  props: {
    param: Object,
  },
  computed: {
    isWinepoint() {
      return this.division === 'winepoint';
    },
  },
  methods: {
    async submit() {
      let message = '';

      this.editable = {
        id: this.param.id,
        isMaster: this.division === 'winepoint',
        isFc: this.division === 'fc',
        isStore: this.division === 'store',
        isManager: this.type === 'manager',
        isStaff: this.type === 'staff',
        isDeleted: this.param.is_deleted,
      };

      try {
        await this.$store.dispatch('modifyUser', this.editable);
        message = `${this.param.email} 계정 설정을 변경하였습니다.`;
      } catch (err) {
        message = '문제가 있어 설정 변경을 하지 못했습니다.';
      }

      this.$modal.clearComponent();
      this.$toast(message);
      this.$table.updateField();
    },
  },
  data() {
    return {
      editable: {},

      type: this.param.is_manager ? 'manager' : this.param.is_staff ? 'staff' : null,
      division: this.param.is_master ? 'winepoint' : this.param.is_fc ? 'fc' : this.param.is_store ? 'store' : '아무것도 아닌 자',
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-frame {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;

  .title-wrapper {
    display: flex;
    justify-content: flex-start;
    padding: 24px 32px;

    .title {
      color: rgb(55, 168, 175);
      font-size: 22px;
    }
  }

  .contents-wrapper {
    display: flex;
    padding: 0 32px;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: column;

    margin-top: 30px;
    margin-bottom: 20px;

    .contents {
      display: flex;
      flex-direction: row;
      padding-left: 15px;
      width: 100%;

      margin-bottom: 20px;

      .contents-header {
        flex: 1;
        font-size: 20px;
        text-align: left;

        border-right: 1px solid rgba(0, 0, 0, 0.2);
        margin: 0 20px 0 0;

        color: rgba(0, 0, 0, 0.5);
      }

      .contents-text {
        flex: 2;

        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/modal/board-modal/ModalModifyUserState.vue